export { uploadFileLangEnUs } from './en-US';
export { uploadFileLangEsMx } from './es-MX';
export { uploadFileLangPtBr } from './pt-BR';
export { uploadFileIntlIds } from './upload-file.ids';
